import { ReadMore } from "Components/ReadMore";
import { useTexts } from "Components/TextContext";
import { usePartnerId } from "Store/partners/partnerHooks";
import { Partner } from "Store/partners/partnerInterfaces";
import React from "react";
import ReactMarkdown from "react-markdown";
import { DescriptionNoMargin } from "../Features/CheckPrice/Products/Advice/adviceStyled";
import { FinAutIcon, Wrapper } from "./styled";

export const AdviceAuthorizedIcon = (): React.ReactElement | null => {
  const { getText } = useTexts();
  const partnerId = usePartnerId();
  const allowedPartners = [Partner.STOREBRAND, Partner.HUSEIERNE, Partner.COOP];
  if (!allowedPartners.includes(partnerId as Partner)) {
    return null;
  }

  return (
    <Wrapper>
      <div>
        <FinAutIcon />
      </div>
      <ReadMore
        title={getText("advicepage.adviceauthorizedicon.title")}
        buttonName={getText("advicepage.adviceauthorizedicon.buttonname")}
      >
        <DescriptionNoMargin>
          <ReactMarkdown linkTarget="_blank">
            {getText("advicepage.adviceauthorizedicon.description")}
          </ReactMarkdown>
        </DescriptionNoMargin>
      </ReadMore>
    </Wrapper>
  );
};
